import { BehaviorSubject } from "rxjs";
import { history } from "../../services/helpers/history";
import { getRandomString } from "../../helpers/helperFunctions";


const queryString = require("query-string");
const axios = require("axios");

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

export const authenticationService = {
  login,
  logout,
  loginOnHpId,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};

function login(data) {
  localStorage.setItem("currentUser", JSON.stringify(data));
  currentUserSubject.next(data);
  history.push("/");
  return data;
}

function loginOnHpId(setLoading) {
  //if url doesn't contain parameters redirect to HP ID login page
  const config = require("../../config.json");
  const randomState = getRandomString(16);

  const hpidAuthUrl = `${config.hpidConfig.authBaseUrl}authorize?response_type=${config.hpidConfig.responseType}&client_id=${config.hpidConfig.clientId}&redirect_uri=${config.hpidConfig.encodedRedirectUrl}&scope=${config.hpidConfig.scope}&state=${randomState}`;

  if (window.location.search == "") {
    window.location.href = hpidAuthUrl;
  } else {
    const params = queryString.parse(window.location.search);
    if (params?.code) {
      getUserInfo(params.code, setLoading);
    } else {
      window.location.href = hpidAuthUrl;
    }
  }
}

function getUserInfo(code, setLoading) {
  const params = { code: code };
  axios
    .post("api/HPID/GetUserInfo", null, {
      params: params,
    })
    .then((res) => {
      let data = res.data;
      if (typeof data === "string" && data.includes("invalidIdentityProvider")) {
        setLoading(false);
        history.push("/invalidIdentityProvider");
      }
      else if (data?.email !== "" && data?.email !== undefined) {
        var userData = data;
        userData.loginDate = new Date();
        var url=[];
        userData.menu.forEach(menu => {
          if (menu.url==""){
            menu.children.forEach(item=>{
              if (item.url==""){
                item.children.forEach(sub=>{
                  if (sub.url!="/"){
                    url.push(sub.url);
                  }
                });
              }else{
                if(item.url!="/"){
                  url.push(item.url);
                }
              }
            });
          }else{
            if (menu.url!="/"){
              url.push(menu.url);
            }
          }
        });
        userData.urls = url;
        login(userData);
      } else {
        setLoading(false);
        history.push("/userNotRegistered");
      }
    })
    .catch((error) => {
      //alert(error?.response?.data);
      setLoading(false);
      history.push("/userNotRegistered");
      //window.location.href = '/';
      return null;
    });
}

function logout() {
  localStorage.removeItem("currentUser");
  localStorage.removeItem("endUser");
  currentUserSubject.next(null);

  const config = require("../../config.json");
  const randomState = getRandomString(16);

  const hpidUrl = `${config.hpidConfig.authBaseUrl}logout?post_logout_redirect_uri=${config.hpidConfig.encodedRedirectUrl}&state=${randomState}`;

  window.location.href = hpidUrl;
}
